import { SmallBalancesToggle } from '~/components/SmallBalancesToggle'
import {
  SmartAccountBalancesGroupBy,
  useSmartAccountDisplayedBalances,
} from '~/hooks/useSmartAccounts'
import { IAddress } from '~/types'
import { isVaultToken } from '~/utils/vault'

export const ShowSmallBalances = ({
  address,
  showSmallBalances,
  setShowSmallBalances,
}: {
  address: IAddress
  showSmallBalances: boolean
  setShowSmallBalances: (showSmallBalances: boolean) => void
}) => {
  const { isLoading, hasSmallBalances } = useSmartAccountDisplayedBalances(
    address,
    {
      showSmallBalances,
      balancesGroupBy: SmartAccountBalancesGroupBy.Chain,
      tokenFilter: (chainId: number, address: IAddress) =>
        !isVaultToken(chainId, address),
    },
  )

  return (
    <>
      {!isLoading && hasSmallBalances && (
        <SmallBalancesToggle
          isChecked={showSmallBalances}
          onCheckedChange={setShowSmallBalances}
        />
      )}
    </>
  )
}
